import {Column, Table, AutoSizer} from 'react-virtualized';
import NodeOptionsMenu from '../../../misc/NodeMenus';
import { Button, LinearProgress } from "@mui/material"
import { store } from '../../../stores/Store';
import { observer } from 'mobx-react-lite';
import { AlertModal, DisplayValue } from '../../..';
import { Link } from 'react-router-dom';
import { add, addDays, format, formatDistanceToNow } from 'date-fns';
import { Icons } from '../../../misc/Icons';
import ViewQuestionnaire from '../questionnaire/ViewQuestionnaire';
import InlineMenu from '../../../misc/InlineMenu';
import { NodeReference } from '../../../models/Interfaces';
import { UTCDate } from '@date-fns/utc';
import { Theme } from '../../../misc/Theme';


export default observer(function CaseSummaryTable () {

    const { loading, getCaseSummaryTable, tagKeys, orderPhrase } = store.UsageStore
    const rowHeight = 40
    const minWidth = 1800 + (tagKeys.length * 140)

    const getTargetDateColor = (date) => {
        const oneWeekFromNow = addDays(new UTCDate(), 7)
        const twoWeeksFromNow = addDays(new UTCDate(), 14)
        var color = "unset"
        
        if (date < new UTCDate()) {
            color = Theme.palette.error.main
        } else if (date < oneWeekFromNow) {
            color = Theme.palette.warning.main
        }
        return color
    }

    return (
        <>
            <small style={{marginBottom: "5px"}}>
                {getCaseSummaryTable?.length} cases, {orderPhrase}.
            </small>
        
            <div className={`rv-table-wrapper rv-table-md`}  style={{minHeight: "400px"}}>
                <AutoSizer>
                    {({height, width}) => (
                        <Table
                            width={width < minWidth ? minWidth : width}
                            height={height}
                            headerHeight={rowHeight}
                            rowHeight={rowHeight}
                            rowCount={getCaseSummaryTable.length}
                            rowGetter={({index}) => getCaseSummaryTable[index]}>

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="account" />}
                                cellRenderer={(data) => (
                                    <Link onClick={() => store.ToolStore.setOpen(false)} className='link' to={`/app/main/${data.rowData.account?.uid}`}>
                                        {data.rowData.account?.name}
                                    </Link>
                                )} />

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="case" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.case?.name) {
                                        return <span className="font-grey">-</span>
                                    }
                                    if (data.rowData.deletedAt) {
                                        return <div>{data.rowData.case?.name}</div>
                                    }
                                    return (
                                        <Link onClick={() => store.ToolStore.setOpen(false)} className='link' to={`/app/main/${data.rowData.case?.uid}`}>
                                            {data.rowData.case?.name}
                                        </Link>
                                    )
                                }} />
                            
                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="createdAt" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.createdAt) return <span className="font-grey">-</span>
                                    return <span>{format(new Date(data.rowData.createdAt), "yyyy-MM-dd hh:mm")}</span>
                                }} />

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="lastUpdated" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.lastUpdated) return <span className="font-grey">-</span>
                                    return <span>{format(new Date(data.rowData.lastUpdated), "yyyy-MM-dd hh:mm")}</span>
                                }} />
                            
                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="deletedAt" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.deletedAt) {
                                        return <span className="font-grey">-</span>
                                    }
                                    return <span>{format(new Date(data.rowData.deletedAt), "yyyy-MM-dd hh:mm")}</span>
                                }} />

                            {/* <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="nextTargetDate" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.nextTargetDate) {
                                        return <span className="font-grey">-</span>
                                    }
                                    var nextTargetDate = new UTCDate(data.rowData.nextTargetDate)
                                    const color = getTargetDateColor(nextTargetDate)
                                    const phrase = formatDistanceToNow(nextTargetDate, { addSuffix: true }) // format(nextTargetDate, "yyyy-MM-dd")
                                    return <span style={{color: color}}>{phrase}</span>
                                }} />
                            
                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="finalTargetDate" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.finalTargetDate) {
                                        return <span className="font-grey">-</span>
                                    }
                                    var finalTargetDate = new UTCDate(data.rowData.finalTargetDate)
                                    const color = getTargetDateColor(finalTargetDate)
                                    const phrase = formatDistanceToNow(finalTargetDate, { addSuffix: true }) // format(finalTargetDate, "yyyy-MM-dd")
                                    return <span style={{color: color}}>{phrase}</span>
                                }} /> */}

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="subjectNames" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.subjectNames?.length) return <span className="font-grey">-</span>
                                    return <span>{data.rowData.subjectNames.join(", ")}</span>
                                }} />

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="user" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.users?.length) return <span className="font-grey">-</span>
                                    return <span>{data.rowData.users.join(", ")}</span>
                                }} />

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="questionnaires" />}
                                cellRenderer={(data) => <NodeReferenceCell rowData={data.rowData} refs={data.rowData.questionnaires} resourceName="Questionnaire" resourceNamePlural="Questionnaires" />} />

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="enquiries" />}
                                cellRenderer={(data) => <NodeReferenceCell rowData={data.rowData} refs={data.rowData.enquiries} resourceName="Assessment" resourceNamePlural="Enquiries" />} />

                            <Column
                                width={140}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="automations" />}
                                cellRenderer={(data) => <NodeReferenceCell rowData={data.rowData} refs={data.rowData.automations} resourceName="Automation" resourceNamePlural="Automations" />} />

                            {tagKeys.map((tagKey, i) => (
                                <Column
                                    width={140}
                                    dataKey=""
                                    headerRenderer={() => <ColumnHeader value={tagKey} />}
                                    cellRenderer={(data) => {
                                        if (!data.rowData.tags[tagKey]) return <span className="font-grey">-</span>
                                        return <span>{data.rowData.tags[tagKey]}</span>
                                    }} />
                            ))}
                        </Table>
                    )}
                </AutoSizer>

                {loading ? <LinearProgress color="secondary" style={{marginTop: `${rowHeight}px`}} /> : null}
            </div>
        </>
    )
})


function ColumnHeader ({value}) {

    var {order, orderedBy, setOrder, setOrderedBy} = store.UsageStore

    return (
        <div>
            <Button className="btn btn-lowercase" color="info" onClick={() => {
                if (orderedBy !== value) {
                    setOrderedBy(value)
                } else {
                    setOrder(order === "asc" ? "desc" : "asc")
                }
            }}>
                {DisplayValue("dict_key", value)}

                {orderedBy === value ? (
                    <>
                        {order === "asc" ? <Icons.ArrowUp style={{fontSize: "12px"}} /> : <Icons.ArrowDown style={{fontSize: "12px"}} />}
                    </>
                ) : null}
            </Button>
        </div>
    )
}

function NodeReferenceCell ({rowData, refs, resourceName, resourceNamePlural}) {

    const open = (uid: string) => {
        if (uid?.includes("ENQUIRY") && !rowData.deletedAt) {
            store.NodeStore.navigateNode(uid)
            store.ToolStore.setOpen(false)
        } else if (uid?.toLocaleLowerCase().startsWith("q")) {
            AlertModal({width: "700px", body: <ViewQuestionnaire uid={uid} />})
        }
    }

    if (!Array.isArray(refs) || refs.length === 0) {
        return (
            <span className="font-grey">No {resourceNamePlural}</span>
        )
    }

    if (refs.length === 1) {
        return (
            <span className={rowData.deletedAt ? "" : "link"} onClick={() => open(refs[0].uid)}>
                {refs[0].name ? refs[0].name : `1 ${resourceName}`}
            </span>
        )
    }

    return (
        <InlineMenu opener={(
            <span className="link">
                {refs.length} {resourceNamePlural}
            </span>
        )}>
            <div style={{display: "grid", padding: "10px", gap: "10px"}}>
                {rowData.deletedAt ? <p className="warning">This data has been deleted.</p> : null}

                {refs.map((qRef: NodeReference, i) => (
                    <span key={i} className={qRef.uid && !rowData.deletedAt ? "link" : ""} onClick={() => open(refs[i].uid)}>
                        {qRef.name ? qRef.name : qRef.uid}
                    </span>
                ))}
            </div>
        </InlineMenu>
    )
}